import React, { useState } from "react";
import { useSaveOnSpotService } from "./workshopHooks";

const RequireServices = ({ step, onClose, isDark, caseId, onStepComplete }) => {
  console.log("RequireServices rendered with caseId:", caseId);

  const [service, setService] = useState(
    step.serviceType  ? Array.isArray(step.serviceType) ? step.serviceType : [step.serviceType]
    : []);

  const [submitted, setSubmitted] = useState(step.completed);
  const [open, setOpen] = useState(false);

  const toggle = (value) => {
  setService(prev =>
    prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
  );
};

  const isLocked = submitted || step.completed;

  const { mutateAsync: saveService, isPending: loading } = useSaveOnSpotService();

  const services = [
    { label:"Towing Van", value: "TOWING_VAN"},
    { label:"Crane", value:  "CRANE"},
    { label:"On Spot Mechanic", value: "ON_SPOT_MECHANIC"},
    { label:"Advocate", value:"ADVOCATE"},
  ];

  const selectedLabel = services.filter(s => service.includes(s.value)).map(s => s.label).join(", ");

  const handleSubmit = async () => {
    console.log("Submitting service:", service, "for caseId:", caseId);
    if (!service.length) return alert("Please select at least one service");

    try {
      await saveService({ caseId, onSpotService: service });

      setSubmitted(true);
      if (onStepComplete) onStepComplete("services", { serviceType: service });

    } catch (err) {
      alert("Failed to save service: " + err.message);
    }
    setSubmitted(true);

    if (onStepComplete) onStepComplete("services", { serviceType: service });

// 🔥 TEMP FLOW CONTROL
step.completed = true;

// 👉 Move to next step
if (step.caseData) {
  step.caseData.currentStatus = "WORKSHOP_PENDING";
}
  };
//   // 🔥 TEMP UI FIX (until backend connected)
// step.completed = true;
// step.serviceType = service;

  return (
    <div
      className="cw-slideIn"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* 🔥 HEADER */}
      <div
        style={{
          padding: "22px 20px 18px",
          borderLeft: "4px solid #0ea5e9",
          background: isDark
            ? "linear-gradient(135deg, rgba(14,165,233,0.15), transparent)"
            : "linear-gradient(135deg, rgba(14,165,233,0.08), transparent)",
          borderBottom: isDark
            ? "1px solid rgba(255,255,255,0.05)"
            : "1px solid rgba(14,165,233,0.08)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: 28, marginBottom: 6 }}>🚛</div>
            <div
              className="cw-syne"
              style={{
                fontSize: 17,
                fontWeight: 800,
                color: "#0ea5e9",
              }}
            >
              Required Services
            </div>
          </div>

          {/* ❌ CLOSE BUTTON */}
          <button
            onClick={onClose}
            style={{
              width: 36,
              height: 36,
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              background: isDark
                ? "rgba(255,255,255,0.06)"
                : "rgba(99,102,241,0.08)",
              border: isDark
                ? "1px solid rgba(255,255,255,0.12)"
                : "1.5px solid rgba(99,102,241,0.15)",
              color: isDark ? "#fff" : "#6366f1",
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* 🔥 BODY */}
      <div style={{ padding: 20 }}>
        {isLocked ? (
          <div
            style={{
              padding: 18,
              borderRadius: 16,
              background: isDark
                ? "rgba(14,165,233,0.15)"
                : "rgba(14,165,233,0.08)",
              border: "1px solid rgba(14,165,233,0.3)",
            }}
          >
            <div style={{ fontSize: 14, marginBottom: 6 }}>
              🚛 Service Selected
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 6,fontWeight: 700, marginBottom: 8 }}>
              {service.map(v => (
              <span key={v} style={{
                fontSize: 12, fontWeight: 600, padding: "3px 10px", borderRadius: 20,
                background: "rgba(14,165,233,0.2)", color: "#0ea5e9",
                border: "1px solid rgba(14,165,233,0.35)",
              }}>
                {services.find(s => s.value === v)?.label || v}
              </span>
            ))}
            </div>

            <div style={{ fontSize: 13, opacity: 0.8 }}>
              Status: <b>In Progress</b>
            </div>

            <div style={{ fontSize: 12, marginTop: 6, opacity: 0.6 }}>
              Waiting for workshop assignment...
            </div>
          </div>
        ) : (
          <>
            {/* LABEL */}
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              Select Service
            </div>

            {/* 🔥 CUSTOM DROPDOWN */}
            <div style={{ position: "relative", marginBottom: 20 }}>
              <div
                onClick={() => setOpen(!open)}
                style={{
                  padding: "14px",
                  borderRadius: 12,
                  border: isDark
                    ? "1px solid rgba(255,255,255,0.15)"
                    : "1px solid rgba(99,102,241,0.2)",
                  background: isDark
                    ? "rgba(255,255,255,0.05)"
                    : "#fff",
                  color: service
                    ? isDark
                      ? "#fff"
                      : "#111"
                    : isDark
                    ? "rgba(255,255,255,0.5)"
                    : "#888",
                  cursor: "pointer",
                }}
              >
                {selectedLabel || "Choose service"}
              </div>

              {open && (
                <div
                  style={{
                    position: "absolute",
                    top: "110%",
                    width: "100%",
                    borderRadius: 12,
                    overflow: "hidden",
                    background: isDark ? "#0b1220" : "#fff",
                    border: "1px solid rgba(99,102,241,0.2)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                    zIndex: 10,
                  }}
                >
                  {services.map((item) => (
                    <div
                      key={item.value}
                      onClick={() => {
                        toggle(item.value)
                      }}
                      style={{
                        padding: 12,
                        cursor: "pointer",
                        color: isDark ? "#fff" : "#111",
                        transition: "0.2s",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.background = isDark
                          ? "rgba(255,255,255,0.05)"
                          : "#f3f4f6")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.background = "transparent")
                      }
                    >
                      {item.label}
                      {service.includes(item.value) && (
                        <span style={{ 
                          width: 8, height: 8, borderRadius: "50%",
                          background: "#0ea5e9", display: "inline-block",
                          alignSelf: "center"}}/>
                      )}
                    </div>
                  ))}
                  <div
                  onClick={() => setOpen(false)}
                  style={{
                    padding: "10px 12px",
                    cursor: "pointer",
                    color: "#0ea5e9",
                    fontWeight: 700,
                    fontSize: 13,
                    textAlign: "center",
                    borderTop: isDark
                      ? "1px solid rgba(255,255,255,0.08)"
                      : "1px solid rgba(99,102,241,0.1)",
                  }}
                >
                  Done
                </div>
                </div>
              )}
            </div>

            {/* 🔥 SUBMIT BUTTON */}
            <button
              onClick={handleSubmit}
              disabled={isLocked || loading}
              style={{
                width: "100%",
                padding: "14px",
                borderRadius: 14,
                border: "none",
                fontSize: 15,
                fontWeight: 700,
                color: "#fff",
                cursor: isLocked ? "not-allowed" : "pointer",

                background:
                  "linear-gradient(90deg,#6366f1,#8b5cf6,#ec4899)",
                backgroundSize: "200% auto",
                animation: "cw-shimmerLt 4s linear infinite",

                opacity: isLocked ? 0.6 : 1,
                boxShadow: "0 8px 25px rgba(99,102,241,0.35)",
              }}
            >
              {loading ? "Saving..." : "Submit"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RequireServices;